// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2BdUF","footer":"ModalUpdate_footer__2rOlI"};